import { observer } from 'mobx-react';
import { useStore } from 'hooks/useStore';
import SupportTicketWidget from 'components/SupportTicketWidget';
import SupportTicketChat from 'components/SupportTicketChat';
import TicketDetailModal from 'components/TicketDetailModal';
import config from '../../config';

/**
 * SupportTicketShell - Renders global support ticket components when authenticated
 * Includes: Widget (floating button), Chat panel, and Detail modal
 *
 * Gated behind the `jiraTicketingSystem` feature flag (VITE_JIRA_TICKETING_SYSTEM):
 * the "Report an Issue" UI only renders when the flag is present and true.
 */
const SupportTicketShell = () => {
  const {
    UserStore: { isAuthenticated }
  } = useStore();

  if (!config.jiraTicketingSystem || !isAuthenticated) {
    return null;
  }

  return (
    <>
      <SupportTicketWidget />
      <SupportTicketChat />
      <TicketDetailModal />
    </>
  );
};

export default observer(SupportTicketShell);
